import {
    Box,
    FormLabel,
    Grid,
    Stack,
    Typography,
    } from "@mui/material"
  import { getAdmission } from "../../api"
  import React from "react"
  import { useState, useEffect } from "react"
  import { useSnackbar } from "notistack"

const AdmissionDetails = ({user}) => {
    const [admission, setAdmission] = useState({})
    const { enqueueSnackbar } = useSnackbar()

    const fetchAdmission = () => {
        getAdmission(user?.sub)
        .then((res) => {
            setAdmission(res.data)
        })
        .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
    }
  
    useEffect(() => {
        fetchAdmission()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box>
            <Typography variant="h6" sx={{ letterSpacing: 2 }} color="primary">
              ADMISSION DETAILS
            </Typography>
            <Stack spacing={1} sx={{ mt: 2 }} alignItems="flex-start">
              <Grid container spacing={1} mb={2}>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Institute Id</FormLabel>
                    {admission?.instituteId}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Institute</FormLabel>
                    {admission?.institution}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Department</FormLabel>
                    {admission?.department}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Program</FormLabel>
                    {admission?.program || "N/A"}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Year</FormLabel>
                    {admission?.year || "N/A"}
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Admission Date</FormLabel>
                    {admission?.admissionDate ? admission?.admissionDate.split("T")[0] : "N/A"}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Enrollment Status</FormLabel>
                    {admission?.enrollmentStatus || "N/A"}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Avail Hostel Facility</FormLabel>
                    {admission?.availHostelFacility || "N/A"}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Avail Transportation Facility</FormLabel>
                    {admission?.availTransportationFacility || "N/A"}
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          </Box>
    )
}

export default AdmissionDetails